<template>
  <nav>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      persistent
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          data-testid="change-user-language-button"
          v-bind="attrs"
          icon
          absolute
          right
          top
          class="mt-n2 mr-n2"
          v-on="on"
          @click="$emit('proceedSubmit', '', '')"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <v-card data-testid="change-user-language-card">
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter="updateLanguage"
          @submit.prevent
        >
          <v-toolbar
            dark
            color="accent"
          >
            <v-btn
              data-testid="close-button"
              icon
              dark
              @click="reloadForm"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title class="text-h5 font-weight-bold">
              {{ $t('changePreferredLanguage') }}
            </v-toolbar-title>
            <v-spacer />
            <v-btn
              data-testid="submit-button"
              type="submit"
              :disabled="loading"
              color="white"
              class="text-body-1 darktext--text text-none rounded-xxl px-4"
              @click="updateLanguage"
            >
              {{ $t('save') }}
            </v-btn>
          </v-toolbar>
          <AlertMessages
            v-if="alertValue"
            alert-type="error" 
            :alert-msg="alertMsg"
            @reset="alertValue = false"
          />
          <v-card-text class="pt-0 pl-6">
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="py-15 px-md-12">
                  <v-radio-group v-model="language">
                    <v-radio
                      v-for="option in languageOptions"
                      :key="option.id"
                      data-testid="language-input"
                      :value="option.id"
                      color="accent"
                      class="black--text"
                    >
                      <template slot="label">
                        <country-flag
                          :country="option.flag"
                          size="normal"
                          class="ma-0"
                        />
                        <span>
                          {{ $t(option.language) }}
                        </span>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { updateUser } from '../../api/userApi'
import AlertMessages  from '../../components/AlertMessages'
import CountryFlag from 'vue-country-flag'

export default {
    components: {
        AlertMessages,
        CountryFlag
    },
    data(){
        return{
            dialog: false,
            valid: true,
            languageOptions: [{'id': 'en', 'language': 'english', 'flag': 'gb'}, {'id': 'sv', 'language': 'swedish', 'flag': 'se'}, {'id': 'mk', 'language': 'macedonian', 'flag': 'mk'}],
            language: localStorage.user ? JSON.parse(localStorage.user).language : '',
            languageReadable: this.language == 'en' ? i18n.t('english') : this.language == 'sv' ? i18n.t('swedish') : this.language == 'mk' ? i18n.t('macedonian') : i18n.t('english'),
            alertMsg: '',
            alertValue:false,
            userId: window.$cookies.get('id'),
            loading: false,
        }
    },
    methods: {
        async updateLanguage(){
            this.$refs.form.validate()
            if(this.valid){
                this.loading = true
                var alertType = ''
                var alertMsg = ''
                try {
                    let data = {
                        data: {
                            type: "users", 
                            id: this.userId,
                            attributes: {
                                language: this.language.trim(),
                            }
                        }
                    };
                    const response = await updateUser(this.userId, data)
                    if(response.status == 200) {
                        i18n.locale = this.language.trim()
                        window.$cookies.set("language", i18n.locale, 0, null, process.env.VUE_APP_DOMAIN)
                        alertMsg =  i18n.t('editUserSuccess')
                        alertType = 'success'
                        this.$emit('proceedSubmit', alertMsg, alertType)
                        this.$emit('proceedPreferedLanguage', response.data.data.attributes)
                    }
                } catch (e) {
                    if(e.response){
                        this.alertValue = true
                        alertType = 'error'
                        alertMsg =  i18n.t('serverError')
                        this.$emit('proceedSubmit', alertMsg, alertType)
                    }
                }
                this.loading = false
                this.dialog = false
            }
        },
        reloadForm(){
            this.dialog = false,
            this.alertMsg = ''
            this.language = localStorage.user ? JSON.parse(localStorage.user).language : ''
        }
    }
}
</script>